import React, {Fragment} from 'react';
import {
    Grid,
    TextField,
} from "@material-ui/core";
import CustomInput from "components/CustomInput/CustomInput.jsx";


const EmailsPanel = ({ classes, additionalEmails, activeEditEmail, editedEmail, handleChange, handleChangeEmail, handleActiveInput}) => {
    return (
        <div>
            <Grid item md={12} sm={12}>
                <TextField
                    className={classes.wide}
                    multiline
                    rowsMax="10"
                    id="additionalEmails"
                    label="Additional Email(s)"
                    name="additionalEmails"
                    value={additionalEmails}
                    onChange={handleChange}
                    margin="normal"
                    variant="outlined"
                />
                <div className={classes.nb}>*separate multiple emails with comma</div>
                {
                    editedEmail && editedEmail.map((emails,i)=>(
                    <Fragment key = {i}>
                        <Grid item md={10} sm={7}>
                            <CustomInput
                                labelText="Exisiting Email"
                                id="exisitingEmail"
                                formControlProps={{
                                    fullWidth: true
                                }}
                                inputProps={
                                    {
                                        disabled: !(activeEditEmail === i),
                                        value: editedEmail[i],
                                        name: "emails",
                                        type: "email",
                                        onChange: (event) => handleChangeEmail(event, i),
                                    }}
                            />
                        </Grid>
                        <Grid item md={2} sm={2} className={classes.edit}>
                            <div onClick={()=> handleActiveInput(emails,i, 1)} style={{color:"#dd2735",cursor:"pointer", margin:"0 0 10px 10px"}} autoFocus>
                                Edit
                            </div>
                        </Grid>
                    </Fragment>
                    ))
                }
            </Grid>

        </div>
    );
};

export default EmailsPanel;



// WEBPACK FOOTER //
// ./src/views/EmailSettings/EmailsPanel.js